import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = { class: "input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["phone-input-container", {valid: $setup.isValid || $setup.numberInput == ''}])
  }, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.countryCode) = $event))
    }, [
      _createTextVNode(_toDisplayString($setup.countryCode), 1 /* TEXT */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.codeList, (code) => {
        return (_openBlock(), _createElementBlock("option", { value: code }, _toDisplayString(code) + " +" + _toDisplayString($setup.getCountryCallingCode(code)), 9 /* TEXT, PROPS */, _hoisted_1))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */), [
      [_vModelSelect, $setup.countryCode]
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        class: "phone-input",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.numberInput) = $event)),
        onKeyup: $setup.handleKey,
        placeholder: " "
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
        [_vModelText, $setup.numberInput]
      ]),
      _createElementVNode("label", _hoisted_4, _toDisplayString($props.label || "Phone Number"), 1 /* TEXT */)
    ])
  ], 2 /* CLASS */))
}